import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgUseVO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly value: RoomBrandBgUse) {
    JsonSchemaValidator.assert(RoomBrandBgUseVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgUse {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
